@if (inputForm && fieldKey && fieldConfig) {
  <ng-container *transloco="let t">
    <form [formGroup]="inputForm">
      @switch (fieldConfig.fieldConfigTypeId) {
        @case (FieldConfigType.BOOLEAN) {
          <div class="col-12 pt-20-10">
            <app-checkbox [formControlName]="fieldKey" [label]="label"/>
          </div>
        }
        @case (FieldConfigType.SELECT) {
          <div class="col-12 pt-20-10">
            <app-select [formControlName]="fieldKey" [items]="fieldConfig.options" valueKey="id"
                        [translatedLabels]="translatedLabels" [label]="label"/>
          </div>
        }
        @case (FieldConfigType.MULTISELECT) {
          <app-multiselect-dropdown [options]="options"
                                    [formControlName]="fieldKey"
                                    [dropdownLabel]="label"/>
        }
        @case (FieldConfigType.TEXT) {
          <div class="col-12 pt-20-10">
            <app-input [type]="'text'" [formControlName]="fieldKey" [label]="label"/>
          </div>
        }
        @case (FieldConfigType.NUMBER) {
          <div class="col-12 pt-20-10">
            <app-input [type]="'number'" [formControlName]="fieldKey" [label]="label"/>
          </div>
        }
        @case (FieldConfigType.DATE) {
          <app-date-time-input [formControlName]="fieldKey" [displayTime]="false"
                               [label]="label | titlecase"/>
        }
        @case (FieldConfigType.TIME) {
          <app-duration-input [formControlName]="fieldKey"
                              [label]="label | titlecase"/>
        }
      }
    </form>
  </ng-container>
}
